export default class validationStateModel {
  /**
   * @param  {object} keyValuePairs
   */
  constructor(keyValuePairs: any) {
    for (let key in keyValuePairs) {
      // @ts-ignore
      this[key] = keyValuePairs[key];
    }
  }
}
